import { Injectable } from "@angular/core";
import html2canvas from 'html2canvas';

@Injectable({
    providedIn: 'root',
})
export class PrintingService {
    printElement = (element: HTMLElement): void => {
        // const canvas = document.createElement('canvas');
        // canvas.style.width = element.clientWidth.toString();
        // canvas.style.height = element.clientHeight.toString();
        // this.scaleCanvasForPrinting(canvas);
        // const options = { canvas: canvas };

        // html2canvas(element, options)

        html2canvas(element)
            .then((canvas) => {
                const result = canvas.toDataURL("image/png");
                this.showPrintDialog(result);
            });
    }

    private showPrintDialog = (base64Image: string): void => {
        const win1 = window.open('', '', `height=${window.innerHeight}, width=${window.innerWidth}`);

        if (!win1) return;

        const doc = win1.document;

        doc.write('<html>');
        doc.write('<head>');
        doc.write('</head>');
        doc.write('<body>');
        doc.write(`<img src="${base64Image}" />`);
        doc.write('</body>');
        doc.write('</html>');

        window.setTimeout(() => {
            win1.print();
            win1.close();
        }, 100);
    }

    private backingScale = (): number => {
        if (window.devicePixelRatio && window.devicePixelRatio > 1)
            return window.devicePixelRatio;

        return 1;
    }

    private parsePixelValue = (value: string | any): number => {
        return parseInt(value, 10);
    }

    private scaleCanvasForPrinting = (canvas: HTMLCanvasElement): void => {
        const scaleFactor = this.backingScale();
        const canvasStyle = window.getComputedStyle(canvas);

        canvas.width = this.parsePixelValue(canvasStyle.width) * scaleFactor;
        canvas.height = this.parsePixelValue(canvasStyle.height) * scaleFactor;
    }
}